import { z } from "zod";

export const variableValueSchema = z.union([z.number(), z.boolean(), z.string()]);

export const referenceVariableRoleSchema = z.string().min(1);

export const variableRefIdSchema = z.string().regex(/^\d+:[^: ]+$/);

export const referenceVariableConfigSchema = z.object({
  type: z.literal("reference"),
  // why can't I use z.union() or .or()?
  refId: variableRefIdSchema.optional(),
  role: referenceVariableRoleSchema.optional(),
});

export const scopedVariableConfigSchema = z.object({
  type: z.literal("scoped"),
  role: z.string(),
  initialValue: variableValueSchema,
});

export const variableConfigSchema = z.union([
  z.number(),
  z.string(),
  z.boolean(),
  z.discriminatedUnion("type", [scopedVariableConfigSchema, referenceVariableConfigSchema]),
]);
